import { FuelIcon, FuelLink, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import { ChildrenContainer, Container } from './styled';
import { FeatureProps } from './types';

export const Feature: FC<FeatureProps> = ({ icon, title, children, learnMoreAction }) => (
  <Container>
    <FuelIcon size="medium" name={icon} iconStyle="filled" />
    <FuelTypography weight="bold" size="body-lg">
      {title}
    </FuelTypography>
    <ChildrenContainer>
      <div>{children}</div>
      {!!learnMoreAction && <FuelLink onClick={learnMoreAction}>Saiba mais</FuelLink>}
    </ChildrenContainer>
  </Container>
);
